import * as Yup from 'yup';

export const AddChannelSchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  categoryId: Yup.string().required('This field is required'),
  contentId: Yup.array().min(1, 'This field is required'),
  minTargetAge: Yup.string().required('This field is required'),
});

export const EditChannelSchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
});

export const AddVideoSchema = Yup.object().shape({
  title: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  link: Yup.string().required('This field is required'),
  contentIds: Yup.array().min(1, 'This field is required'),
  musicType: Yup.string().required('This field is required'),
  genre: Yup.string().test('Video', 'This field is required', function (value) {
    const { classification } = this.parent;
    if (classification === 'Video') {
      return Yup.string().required().isValidSync(value);
    }
    return true;
  }),
  uploadingDate: Yup.date().test('New & Coming Soon', 'This field is required', function (value) {
    const { genre } = this.parent;
    if (genre === 'New & Coming Soon') {
      return Yup.date().required().isValidSync(value);
    }
    return true;
  }),
  trendingFromDate: Yup.date().test(
    'New & Coming Soon',
    'This field is required',
    function (value) {
      const { genre } = this.parent;
      if (genre === 'Trending Now') {
        return Yup.date().required().isValidSync(value);
      }
      return true;
    }
  ),
  trendingToDate: Yup.date().test('New & Coming Soon', 'This field is required', function (value) {
    const { genre } = this.parent;
    if (genre === 'Trending Now') {
      return Yup.date().required().isValidSync(value);
    }
    return true;
  }),
  seasonId: Yup.string().test('hasSeason', 'This field is required', function (value) {
    const { hasSeason } = this.parent;
    if (hasSeason) {
      return Yup.string().required().isValidSync(value);
    }
    return true;
  }),
  episode: Yup.number().test('hasSeason', 'This field is required', function (value) {
    const { hasSeason } = this.parent;
    if (hasSeason) {
      return Yup.number().required().isValidSync(value);
    }
    return true;
  }),
});

export const EditVideoSchema = Yup.object().shape({
  link: Yup.string().required('This field is required'),
  title: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  musicType: Yup.string().required('This field is required'),
});

export const AddCategorySchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  color: Yup.string().required('This field is required'),
  contentId: Yup.array().min(1, 'This field is required'),
});

export const EditCategorySchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  color: Yup.string().required('This field is required'),
});

export const AddSeriesSchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
});

export const AddEpisodeSchema = Yup.object().shape({
  episode: Yup.number().required('This field is required'),
  id: Yup.string().required('This field is required'),
});

export const AddAppUserSchema = Yup.object().shape({
  email: Yup.string().email().required('This field is required'),
  fullName: Yup.string().required('This field is required'),
  password: Yup.string()
    .min(8, 'It must be at least 8 characters')
    .required('This field is required'),
  type: Yup.string().required('This field is required'),
  pin: Yup.string()
    .length(4)
    .test('type', 'This field is required', function (value) {
      const { type } = this.parent;
      if (type === 'Parent') {
        return Yup.string().length(4).required().isValidSync(value);
      }
      return true;
    }),
});

export const EditAppUserSchema = Yup.object().shape({
  email: Yup.string().email().required('This field is required'),
  fullName: Yup.string().required('This field is required'),
});

export const AddDashboardUserSchema = Yup.object().shape({
  email: Yup.string().email().required('This field is required'),
  username: Yup.string().required('This field is required'),
  password: Yup.string()
    .min(8, 'It must be at least 8 characters')
    .required('This field is required'),
  roleId: Yup.mixed().required('This field is required'),
});

export const EditDashboardUserSchema = Yup.object().shape({
  email: Yup.string().email().required('This field is required'),
  username: Yup.string().required('This field is required'),
  roleId: Yup.mixed().required('This field is required'),
});

export const AddRoleSchema = Yup.object().shape({
  name: Yup.string().required('This field is required'),
});

export const AddBadgeSchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  categoryId: Yup.string().required('This field is required'),
});

export const EditBadgeSchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
});

export const AddBadgeVideoSchema = Yup.object().shape({
  channelId: Yup.string().required('This field is required'),
  videoId: Yup.string().required('This field is required'),
});

export const AddPrivacySchema = Yup.object().shape({
  contentEn: Yup.string().required('This field is required'),
  contentAr: Yup.string().required('This field is required'),
});

export const AddNotificationSchema = Yup.object().shape({
  title: Yup.string().required('This field is required'),
  message: Yup.string().required('This field is required'),
  privacy: Yup.string().required('This field is required'),
  channels: Yup.array().min(1, 'This field is required'),
});

export const ReplyTicketSchema = Yup.object().shape({
  content: Yup.string().required('This field is required'),
});

export const AddFAQSchema = Yup.object().shape({
  questionEn: Yup.string().required('This field is required'),
  questionAr: Yup.string().required('This field is required'),
  answerEn: Yup.string().required('This field is required'),
  answerAr: Yup.string().required('This field is required'),
});

export const AddAppDiscoverySchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
});

export const PublishChromeExtensionSuggestioSchema = Yup.object().shape({
  channelId: Yup.string().required('This field is required'),
  classification: Yup.array().min(1, 'This field is required'),
  title: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  contentIds: Yup.array().min(1, 'This field is required'),
  musicType: Yup.string().required('This field is required'),
});

export const ChromeExtensionSuggestioSettingsSchema = Yup.object().shape({
  approvalRules: Yup.array().of(
    Yup.object().shape({
      adminsRequiredCount: Yup.number().required('This field is required'),
      parentsRequiredCount: Yup.number().required('This field is required'),
    })
  ),
  rejectionRules: Yup.array().of(
    Yup.object().shape({
      adminsRequiredCount: Yup.number().required('This field is required'),
      parentsRequiredCount: Yup.number().required('This field is required'),
    })
  ),
});

export const AddKeywordchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
});

export const PublishComingSoonSchema = Yup.object().shape({
  link: Yup.string().required('This field is required'),
});

export const PublishChannelAiSuggestioSchema = Yup.object().shape({
  channelId: Yup.mixed().required('This field is required'),
  classification: Yup.array().min(1, 'This field is required'),
  title: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  contentIds: Yup.array().min(1, 'This field is required'),
  musicType: Yup.string().required('This field is required'),
});

export const PublishParentSuggestioSchema = Yup.object().shape({
  channelId: Yup.string().required('This field is required'),
  classification: Yup.array().min(1, 'This field is required'),
  title: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  contentIds: Yup.array().min(1, 'This field is required'),
  musicType: Yup.string().required('This field is required'),
});

export const PublishChannelParentSuggestioSchema = Yup.object().shape({
  name: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  description: Yup.object().shape({
    en: Yup.string().required('This field is required'),
    ar: Yup.string().required('This field is required'),
  }),
  categoryId: Yup.string().required('This field is required'),
  contentIds: Yup.array().min(1, 'This field is required'),
  minTargetAge: Yup.string().required('This field is required'),
});

export const PublishMultiChannelAiSuggestioSchema = Yup.object().shape({
  channelId: Yup.mixed().required('This field is required'),
});
